import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router';
import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { persistor, store } from 'redux/store';

import App from './App';

import 'css/reset.css';
import 'css/variables.css';
import 'css/fonts.css';
import 'css/index.css';
import 'css/buttons.css';
import 'css/snippets.css';
import 'css/notiflix.css';
import 'slick-carousel/slick/slick.css';
import 'css/slick-carousel.css';

Notify.init({
  fontFamily: 'Gilroy',
  fontSize: '12px',
  timeout: 5000,
  useIcon: false,
  success: {
    background: 'var(--base-5)',
    textColor: 'var(--base-2)',
  },
  failure: {
    background: 'var(--base-5)',
    textColor: 'var(--base-2)',
  },
  warning: {
    background: 'var(--base-5)',
    textColor: 'var(--base-2)',
  },
});

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </StrictMode>,
);
